module.exports = __webpack_public_path__ + "static/media/dr-carmen-padilla-old.f8e7701d.jpg";